export default {
    tabs: {
        profile: 'About me',
        documents: 'Documents',
    },
    score: {
        incompleteTitle: 'Important!',
        incompleteText:
            '<strong>Your profile is not being promoted as much as it could be!</strong> Completing your Highered profile and switching your status to being found by recruiters are the most important and easiest steps to increase the chances of being discovered by an employer.',
        completeTitle: 'Your profile is complete!',
        completeText:
            'Welcome to the international Top Talent Community. Next, accelerate your connection with international and local recruiters by turning on the {0} function. Give yourself an edge and be fast-tracked to relevant job opportunities. ',
        percentageComplete: '{percentage}% complete',
        beDiscovered: 'Be Discovered',

        fields: {
            FIRST_NAME: 'First name',
            LAST_NAME: 'Last name',
            NATIONALITY: 'Nationality',
            SKILLS: 'Skills',
            PREFERENCES: 'Preferences (Industry and Function)',
            STUDY_PROGRAMS: 'Education + Graduation Date',
            WORK_EXPERIENCE: 'Work experience',
            SUMMARY: 'Summary',
            PROFILE_PICTURE: 'Profile picture',
            WORK_AUTHORIZATION: 'Work authorization',
            LANGUAGES: 'Languages',
            LOCATION: 'Current Location',
            GENDER: 'Gender',
        },
    },
    emptyProfileInfo: {
        title: '<strong>Welcome to Highered,</strong><br />the community of top talent!',
        description01:
            "Make your Highered profile stand out by filling it out completely. It's easy and only takes a few minutes, but it's crucial for getting <strong>found by recruiters</strong>.",
        description02:
            "So go ahead, give it your all and let's get you on the path to <strong>fast-track you to your dream job!</strong>",
        completeMyProfile: 'Complete my profile',
    },

    personalDetails: {
        generateCV: 'Download CV',
        beDiscoveredMode: 'Be discovered mode',
        studyProgram: '{year} - {level} in {program}',

        prompt:
            "Take a moment to tell us about yourself, your passions, and what you're striving for. Filling out this section fully will make you <strong>stand out to potential employers</strong> and allow you to personalize the communication and opportunities you receive.",
        overview: 'Overview',

        firstName: 'First name',
        lastName: 'Last name',
        uploadPhoto: 'Upload photo',
        gender: 'Gender',
        pronouns: 'Pronouns',
        contactEmail: 'Contact email',
        phoneNumber: 'Phone number',

        nationality: 'Nationality',
        addNationality: 'Add nationality',
        currentLocation: 'What is your current location?',
        workAuthorization: 'Work authorization',
        addWorkAuthorization: 'Add work authorization',
        numberOfYears: '{years} year(s)',

        beDiscoveredModeTooltipActive:
            'You are now on "Be Discovered" mode. This means your profile is soon visible to hiring managers and recruiters are allowed to connect with you and share job openings that match your skills.',
        beDiscoveredModeTooltipInactive:
            'Turn on "Be Discovered" to make your profile visible to potential employers. By turning this on, recruiters will soon be able to connect and share relevant opportunities with you. By activating this function you agree to our Terms and Conditions and acknowledge you have read our Privacy Policy.',

        whatIsDiscoveredMode: 'What is Be Discovered mode?',

        attributes: {
            job: 'I am actively looking for new opportunities',
            flex: 'I am open to remote or hybrid work',
            relo: 'I am open to relocation',
            lgb: 'I identify as a member of the LGBTQ+ Community',
            eth: 'I identify as belonging to an ethnic minority',
            pwd: 'I identify as a person with a disability',
        },
        genderOptions: {
            M: 'Male',
            F: 'Female',
            B: 'Non-binary',
            O: 'Other',
            N: 'Prefer not to say',
        },
        pronounOptions: {
            'he/him': 'He/Him',
            'she/her': 'She/Her',
            'they/them': 'They/Them',
            other: 'Other',
            prefer_not_to_say: 'Prefer not to say',
        },
        jobOptions: {
            internship: 'Internship',
            graduate_program: 'Graduate program',
            part_time: 'Part-time',
            full_time: 'Full-time',
            volunteer: 'Volunteer',
        },

        voluntaryPrompt:
            '<strong>Voluntary to submit.</strong>&nbsp;We support out diverse talent community and welcome anyone to indicate if you identify as belonging to the below as Employers emphasize the importance of ensuring support of a diverse workforce. Employers are not able to ask prior to having given an offer of employment.',

        extras: {
            discover: 'Be discovered by recruiters',
            discoverBullet1:
                'This means your profile is soon visible to recruiter who are able to connect with you and share job opening that match your skills. By turning this on you agree to our {tandc} and acknowledge you have read our {privacyPolicy}',

            newsletter: 'Subscribe to the Highered Newsletter',
            newsletterBullet1: 'Stay up to date with the latest employement opportunities',
            newsletterBullet2:
                'Receive tips and advice related to job searching, interviewing, and career advancement',
            newsletterBullet3:
                'Access exclusive descounts and offers from employers and service providers',
        },

        errors: {
            wrongFileType: 'This file type is not supported',
        },
    },

    summary: {
        title: 'My Personal Summary',
        titleWhenEmpty: 'Tell the world what makes you unique',
        emptyButtonText: 'Add Personal Summary',
        subtitle: 'What makes you unique?',
        info:
            "Adding a few more details about you is a great way to tell the employers <strong>what makes you unique</strong>, and what drives and motivates you. After all, it's your profile and your story - so let's make it shine!",
    },

    workExperience: {
        title: 'My experience',
        titleWhenEmpty: 'Tell the world about your work experience',
        emptyButtonText: 'Add experience',
        present: 'Present',

        form: {
            info: 'Do you have some work experience under your belt? Let’s show it off!',
            add: 'Add new work experience',
            header: 'Do you have any experience (work/internship)?',
            companyTitle: 'Name of Employer',
            title: 'Role/Title',
            location: 'Location',
            startDate: 'Start date',
            endDate: 'End date',
            isCurrentJob: 'I am currently working in this role',
            description: 'Description',
            endDateDefaultText: 'End of employment',
            descriptionPlaceholder: 'Describe your role and responsibilities',
        },
    },

    memberships: {
        title: 'Clubs and Affiliations',
        titleWhenEmpty: 'Tell the world about your memberships',
        emptyButtonText: 'Add memberships',

        form: {
            info:
                "Don't forget to showcase your awesome extra-curricular activities! Adding student club or organization memberships to your profile will make you stand out more from the crowd.",
            header: 'Have you been involved in any student teams, clubs or associations?',
            add: 'Add new membership',
            present: 'Present',

            organizationName: 'Name of organization',
            title: 'Role/Title',
            description: 'Description',
            startDate: 'Start date',
            endDate: 'End date',
            endDateDefaultText: 'End of employment',
            isActiveLabel: 'I am an active member of this organization',
            descriptionPlaceholder: 'Describe your role and responsibilities',
        },
    },

    skills: {
        title: 'My skills',
        titleWhenEmpty: "Don't let your skills go unnoticed!",
        emptyButtonText: 'Add skills',

        prompt:
            "Don't let you skills go unnoticed! <strong>Showcase your talents</strong> to potential employers!",
        modalHeader: 'What are your top skills?',
        selectPlaceholder: 'Start typing a skill',
    },

    jobPreferences: {
        title: 'My job preferences',
        titleWhenEmpty: 'Let recruiters understand your aspirations!',
        emptyButtonText: 'Add preferences',

        sectorLabel: 'Industry',
        careerFieldLabel: 'Function',
        preferredEmployersLabel: 'My preferred employer(s)',

        form: {
            info:
                'Adding your preferred work industry preferences, desired functions, and preferred employers to your profile helps you get better opportunities and recruiters to understand your aspirations!',
            sectorLabel: 'What industry would you like to work in?',
            careerFieldLabel: 'What type of functions are you looking for?',
            preferredEmployersLabel: 'Who are your preferred employer(s)?',
            sectorPlaceholder: 'Add up to three',
            careerFieldPlaceholder: 'Add up to three',
        },
    },

    languages: {
        title: 'My languages',
        titleWhenEmpty: 'Hello! ¡Hola! Salut! 你好! Hallo!',
        emptyButtonText: 'Add a language',
        subtitle: 'What languages do you speak?',
        info:
            'Hello! ¡Hola! Salut! 你好! Hallo! What better way to show off your linguistic talents than by adding the languages you speak?',
        language: 'Language',
        proficiency: 'Proficiency',
        proficiencies: {
            '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Elementary proficiency',
            '82edcac6-693b-42ea-bf24-0a52774f395c': 'Limited working proficiency',
            'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Professional working proficiency',
            '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Full professional proficiency',
            '250d296e-d6db-46fb-8c44-07950db80ec4': 'Native or bilingual proficiency',
        },

        languages: {
            '5f42f65a-8224-4cda-acff-cb00537324b6': 'Abkhazian',
            'bd0cf3ab-5818-4a13-89b6-9ab5245a89d6': 'Afar',
            'd406ac37-def4-49ed-9129-5ecad4d157cd': 'Afrikaans',
            'ca2d7b8f-4603-49da-aee0-fb338a56c425': 'Akan',
            'a75c91df-5cd5-4a87-9592-e6e8baf44839': 'Albanian',
            'e254ec10-698d-433a-b876-0d91424b64af': 'Amharic',
            '3d5c5ded-4d8e-459a-8e4a-0ff479c2cdd9': 'Arabic',
            '28ffeee3-01ea-4e91-9013-cc253a2d359e': 'Aragonese',
            '292671d6-0ceb-4ebe-adaa-f7ee414b43c0': 'Armenian',
            '9e713bce-bbe6-4265-889a-3f3c9305b108': 'Assamese',
            '6ce545b2-f36e-4aa5-966b-88a5e20e0bee': 'Avaric',
            'e908b880-17e6-4f53-af67-605727170ea7': 'Avestan',
            '8f58b9be-b7fa-4d72-ac05-4a0603e5c991': 'Aymara',
            'bcac69b3-790b-49c1-b68c-c6ddd9ff59e7': 'Azerbaijani',
            '4608febf-0868-4274-b785-b95f34661c93': 'Bambara',
            '991f73c1-b348-49a6-bef9-187307e53d3c': 'Bashkir',
            'db377ffa-402f-415e-bce4-0d33b6beecf6': 'Basque',
            '0434b36b-bd9a-4a5e-9478-324dce6ab6d7': 'Belarusian',
            '3bf06406-9f15-4ec2-a023-b576c0439b0a': 'Bengali',
            'c76b914e-c8df-4f11-a0c5-b1bd7d2792a2': 'Bihari',
            'cf42d058-18fe-4fad-878d-122c8fb31d21': 'Bislama',
            '7a0ab095-cfd1-4d22-b520-b80ebe1b8ae7': 'Bosnian',
            'ae96b9ee-6b13-4f11-92d1-e2415f97cd60': 'Breton',
            'af477d92-4c5a-4359-854a-f3a748ea5390': 'Bulgarian',
            '62bc9b34-37fd-45ab-95d2-62a57ccc8ad3': 'Burmese',
            'fa772127-a46b-4dc2-87c4-e5cba34d772e': 'Catalan',
            '98037fda-3b53-49e3-bf23-fdffcad86e34': 'Central Khmer',
            '76d2dd42-78b2-4afb-8b90-313997d3e8eb': 'Chamorro',
            '7917d3a3-abc8-44e0-8596-0e5bf1122159': 'Chechen',
            '42dee0a3-df67-4b88-a4b1-f22d712392b6': 'Chewa/Nyanja',
            '404f1770-2b92-428f-a8d9-4249ee102e25': 'Chinese Cantonese',
            '09dc5449-61c2-49b4-82c5-a8461ce4edbf': 'Chinese Mandarin',
            'd3726732-8de9-407c-92d0-1563f0c24cc0': 'Chinese Min',
            '918e6599-2ca0-4bab-b3ec-9b998ec16988': 'Chinese Wu',
            '50c3aff1-9418-4dd0-b0fe-8525c7e2674a': 'Church Slavic, Old Bulgarian',
            '2190e8dd-cee6-492b-85af-0440e60276fb': 'Chuvash',
            'c0494f39-15e4-4c7f-a444-640166123d04': 'Cornish',
            'd5741fcb-0d98-43ab-aa5f-854428c2ed0d': 'Corsican',
            '08a0876b-15ea-4181-9f79-5539b8037ab1': 'Cree',
            'a14a7e9a-3bf9-471e-aac4-936689779ee4': 'Croatian',
            'fe13d0ec-a12f-4eae-b48d-c421deb9eed5': 'Czech',
            '66c42a17-f679-4887-adda-517915919b57': 'Danish',
            '46d0f113-a23a-43e6-83a9-609ef20ce28e': 'Dutch',
            '735b745b-1ef9-4bce-97b4-28b704b0e157': 'Dzongkha',
            '8140e58e-bcda-4747-a62a-187eae0d11b6': 'English',
            '94f9494a-9c2b-4713-917f-b4f2e4d50e04': 'Esperanto',
            '11a14b2b-8d25-438a-8a4f-60bc70b57c04': 'Estonian',
            '01f44f85-e86d-43fa-9896-bf5b03151d0f': 'Ewe',
            'dceb9df9-33e9-499d-bc52-429f47155233': 'Faroese',
            'e206d7b8-a990-4de4-8583-f779cbe6afa4': 'Fijian',
            '9e3ff546-8e7b-4b44-84ca-cfe4d23a6d9f': 'Finnish',
            '664a4973-8dda-489c-a430-b8e869464a6c': 'French',
            'd950d3a7-2b86-49f7-ba16-ac0e30a7b75f': 'Fulah',
            '7ccdcc1b-4bdf-452e-af79-ff77956cc73f': 'Gaelic',
            '2733b347-e548-4906-b25d-11431b209dea': 'Galician',
            '1aeb67f0-ae42-4db9-8fd8-8dfc7e9fb47b': 'Ganda',
            '7f31fb97-e400-4c85-aad3-3c65fcd09c8d': 'Georgian',
            'a49aa1fb-ac1e-436c-8e99-7416f322c30e': 'German',
            'fe9f4451-10f9-47b3-94d1-b395262c6be8': 'Greek',
            '0cdee359-c96e-4406-a36b-607d6503391f': 'Greenlandic, Kalaallisut',
            '34040315-b2b1-4b46-8975-602331f34702': 'Guarani',
            '637e874f-cb0d-426a-90c6-3b0cfa927781': 'Gujarati',
            '3c978e67-17c0-4f61-92ef-9cb8ff096d4c': 'Haitian',
            '2dc4a9cd-6423-4424-984d-0083e38248d7': 'Hausa',
            'e17250b5-8f19-44b2-b4e0-65980af0669d': 'Hebrew',
            '19406be7-6887-4131-943f-1e3f5f412331': 'Herero',
            'babb1057-756f-42ed-872b-acbd67b0ba35': 'Hindi',
            'da5c53cd-71d8-42f5-9ed8-6df4421aec26': 'Hiri Motu',
            '4b3892ee-5f73-4267-ade5-b2dece6c5e9c': 'Hungarian',
            '92aaefea-5135-477b-9587-d400dbe41b63': 'Icelandic',
            '99063b76-2c18-40e9-ad52-0d0199c1be4f': 'Ido',
            '3fdc817d-e4f0-4af8-be5d-06ce2895cb15': 'Igbo',
            '37b9729d-ff77-4743-aebb-10889f31ea0f': 'Indonesian',
            '8a44ea57-fae8-462c-b94e-9ebc86ee1aa8': 'Interlingua',
            '89bf5b78-dfd3-48b6-8daa-90127c28a38e': 'Interlingue/Occidental',
            'f6c52947-0270-4b05-81ce-2819dfc6d971': 'Inuktitut',
            'e9052826-28b4-41ab-8653-1e3cf57d6fb9': 'Inupiaq',
            '4624b204-23a4-4945-9352-2ff2fe65e8be': 'Irish',
            'b185f320-b067-47c8-b375-94a3bc150fb2': 'Italian',
            'b4763daa-e01a-4f69-bb57-1f3c5fc0fedf': 'Japanese',
            '91e669f7-3c25-492a-9ebe-cb9fab0c7bf3': 'Javanese',
            'd05d33a7-c888-4966-a3a8-e4b0bb249032': 'Kannada',
            '54a4fb91-5693-44b1-b637-0a58f7e6d0dd': 'Kanuri',
            'f2fae1c6-e93a-440b-9adf-8095e6027cec': 'Kashmiri',
            '41838318-1ef6-48ad-8d6d-9982442b3c0b': 'Kazakh',
            'd61a3893-fd63-47c1-a24f-088931b168d9': 'Kikuyu',
            '2e12384d-cefa-46e7-81a6-5f20e4086723': 'Kinyarwanda',
            '12f80a56-3c84-446e-b811-317c999fb187': 'Komi',
            'c2c5c810-c5bb-49fc-9136-5a6a1a585b17': 'Kongo',
            '6cc25d71-442f-4c8c-bc9e-217a1b1abe21': 'Korean',
            'e6df0b08-eb07-4f31-b5cb-5f92cf13fd08': 'Kurdish',
            '4ec6dee5-0a7f-4b45-9aa8-eabedc2fe7c1': 'Kwanyama',
            'cf3f6f9b-b2a3-44e4-ab57-647be9b38a04': 'Kyrgyz',
            '3b2f9b95-f940-4b2f-8131-300126ce6413': 'Lao',
            'e0601055-5d68-4fe8-93a3-7e5f681ed8e1': 'Latin',
            'e568e3c4-8136-421b-af87-c848284db9cf': 'Latvian',
            'b4a02d74-b128-44b4-8a13-91c1e7520539': 'Limburgish',
            '54859ae6-0c5d-4154-860c-32a911e771a7': 'Lingala',
            '9e9bb6a2-d93c-462c-80aa-e7448f77d7a2': 'Lithuanian',
            '613a4391-3d9e-40ce-9535-3d9eec2157c0': 'Luba-Katanga',
            '255a86f2-1c77-46cd-bf8b-9d2e53cdfa19': 'Luxembourgish',
            '3e7024cd-3768-42ff-a39e-7d193998ffb7': 'Macedonian',
            '818ae008-769a-4795-9595-7391d1b576fb': 'Malagasy',
            '38f41ef5-9ee6-4ff8-b0d9-5a91b078c7be': 'Malay',
            '5db7c9b7-baff-4763-890e-d35836a784fa': 'Malayalam',
            '21300817-50b0-4174-a8b8-83809f48623e': 'Maldivian',
            '9a8e5c0a-60bf-4e4e-91e7-6df5382e1e92': 'Maltese',
            '77285af3-3fea-430a-9a94-f87506c17786': 'Manx',
            'baee5980-e62f-47b7-9876-e58a9119ec76': 'Maori',
            '627fc9e4-fdc6-4d1c-bd9b-8b14fccf6af0': 'Marathi',
            'db35a291-066d-4337-9296-25f9e90e5a64': 'Marshallese',
            'd6d54d82-a0a1-4755-b1ba-800336759978': 'Moldovan/Romainan',
            'c091e849-7aee-4a31-ae7b-ac3fcb04e82f': 'Mongolian',
            'b65e409d-7b8d-4428-94ac-cdc9712b0969': 'Nauru',
            'a1e3e78c-7333-468a-a1cf-5cb2c5d7d233': 'Navajo',
            'bb8e6986-4368-4445-9057-15184b760ff0': 'Ndebele, Transvaal',
            'b13dc5d2-773e-420f-818b-e7b89a3a9511': 'Ndebele, Zimbabwean',
            '17c09185-671f-429b-83f7-4c772e8c8cc7': 'Ndonga',
            '6e5398fd-5f7d-412d-9a25-04a2a464d6da': 'Nepali',
            '8886ac26-6121-4309-927c-a00380eb8347': 'Norwegian',
            'ec2770c0-3ca1-4e38-973a-de05cc366062': 'Norwegian Bokmål',
            '2ab6fa3d-55c3-43ec-8402-417064160dd0': 'Norwegian Nynorsk',
            '665db549-57bc-4da8-b6b7-ea8c59b96bac': 'Occitan',
            '1380064b-f500-4669-a532-b4e010591fa6': 'Ojibwa',
            'cb2c1e2b-8c49-41ce-8130-98d4d1ba5165': 'Oriya',
            '5ab28c85-03df-4182-8612-0c4ef6961b20': 'Oromo',
            '7dac0c33-dcb3-4c68-836d-64c2fb74f456': 'Ossetian',
            '63a6ebf6-ce6b-488d-90df-2bc138c1d92e': 'Pali',
            'e2b2777a-75be-48f4-81ee-8f494616f85c': 'Pashto',
            'cc89b166-6f06-4e65-a526-e94109d9ae3a': 'Persian',
            '2576d22a-2a69-443b-a062-da149e4ca81b': 'Polish',
            '41ff8a1f-2ce1-47c7-969e-afe3eadaf549': 'Portuguese',
            'fd56081e-5e1f-4524-b66c-48fad573126f': 'Punjabi',
            'ef153df3-89d5-4375-bd22-17dc180995eb': 'Quechua',
            '36d6b9ee-ec56-4696-bc94-78ce460bc9db': 'Romansh',
            '054bc6ea-8f1c-4ae7-ad96-2116478dfd45': 'Rundi',
            'aff5b699-00fc-4ed5-b088-466a77613093': 'Russian',
            '14b3390c-f9b2-4794-ba10-71dfc317c88d': 'Sami',
            'aabe4f8c-05cb-4388-b141-48508f4d9d45': 'Samoan',
            '004c0761-8282-4ae8-b2f5-8da96082055a': 'Sango',
            'cc4bea18-4978-42a5-b8a7-165d0d346f6f': 'Sanskrit',
            'dd6d8209-2576-4c03-8f05-9f51f169923c': 'Sardinian',
            '2249ec53-b059-4507-99f1-377868ba4dea': 'Serbian',
            '31277571-9b06-4a91-b695-5210b70e33ce': 'Shona',
            '12630110-167f-402e-b6ca-954382eacb79': 'Sichuan Yi, Nuosu',
            'a48c3f4d-b542-45d7-bb4a-1381b5eab895': 'Sindhi',
            'bd0c9994-6ef7-448f-a9e1-5b8b3f15d5ad': 'Sinhala',
            '890146a9-0720-41ac-a2a0-01b210c7847a': 'Slovak',
            '2935bb1f-41a0-4710-a3ee-cab9f9d8ab00': 'Slovenian',
            '97302ed4-be1d-4824-84e7-4ca2f6c7daab': 'Somali',
            'd5a9ebe9-9fe4-4cdc-ac31-5ea9ad59f1a9': 'Sotho (Southern)',
            '77f3bd77-cb78-4bba-a180-7b313862879b': 'Spanish',
            '30bee8a1-4d49-451c-844c-1d2add479a39': 'Sundanese',
            '937e1462-16a5-4ac6-aee0-8ece879f7d18': 'Swahili',
            '1af82ba9-148b-47e6-bd07-3fe9696cb217': 'Swati',
            '0da29f9b-632b-48f2-9243-4e9ab63b68e3': 'Swedish',
            'aa8ac3cd-b874-4dd9-ad2e-c16422a4a259': 'Tagalog',
            '4ba2eeaf-4252-4fb7-bad8-c2e345e48ae0': 'Tahitian',
            'ca2bfcc2-2f99-4692-bf2f-3aea14c769b0': 'Tajik',
            '424bf228-ec11-4a91-aa4d-e3576c1045f1': 'Tamil',
            'c74196ac-4f37-42e7-ba3a-027ec5d4cc06': 'Tatar',
            '979ef794-6a96-4c29-b49a-190d48bfebd2': 'Telugu',
            'ada07460-f971-4dec-a784-ce1423b26056': 'Thai',
            '7135fa16-0dfe-43a1-9829-bb27251a1694': 'Tibetan',
            'fa9b77d4-37e4-462c-be1c-d6b91cfc703d': 'Tigrinya',
            '48c4649b-a4f3-4f63-bbfc-5f69a94ea922': 'Tonga (Polynesian)',
            'a48485d6-c1d0-4a7c-9d20-4864cd648ab2': 'Tsonga',
            '64360495-ef4a-4f1d-ab24-7ba4dd01fadc': 'Tswana',
            '9c7500aa-27be-4deb-b0d1-b23c8d1c50a2': 'Turkish',
            'ba02097d-fca6-4687-b928-7f8eb2147a69': 'Turkmen',
            'c106d103-d983-46a1-8d4c-f876954fcfed': 'Twi',
            '9a68e608-00a7-445e-bdd6-fad53c0a3f24': 'Uighur',
            '235a8b1d-c020-4c0a-ba72-035da40b1cbe': 'Ukrainian',
            '2383edc7-e6f6-402c-b01d-1e0fb11169be': 'Urdu',
            'cf342b00-b385-4511-8f83-6d501ab550ea': 'Uzbek',
            '08507f89-f11a-4a32-8058-72d3d05aab58': 'Venda',
            'e0c943a6-ad92-4ec8-9b48-99e6bb77ad18': 'Vietnamese',
            '1c55b675-7b59-46e5-a710-bafaf0007723': 'Volap\u00fck',
            'd6067b41-5433-4964-97c9-885ba4b52849': 'Walloon',
            'bd4d5121-f608-4273-bdbb-6c29b5a5efce': 'Welsh',
            '76136969-04bf-4165-ab58-24ad36c62642': 'Western Frisian',
            'd7e258ca-ab63-45cc-9e16-40486b62fdc4': 'Wolof',
            'eb507af9-080c-474e-a8b3-03ff4e6c8db9': 'Xhosa',
            'a6c2626b-2bf7-4ab3-9f54-5fec74405dcf': 'Yiddish',
            '29af948a-fbf6-49b4-adf0-351dae0d893c': 'Yoruba',
            '1c549a1b-9eb0-4cd4-b26c-9fb42fce95f6': 'Zhuang',
            '2155a55a-51c1-4b86-a933-9108255e8dd9': 'Zulu',
            '3fab5319-1f3a-4711-b708-dc33c2cf5cf1': 'Other',
        },
    },

    links: {
        title: 'More about me',
        titleWhenEmpty: 'Jazz it up by adding some personal links',
        emptyButtonText: 'Add links',

        modalTitle: 'Links',
        prompt:
            'Here you can link up your social media profile, such as your LinkedIn profile, and add assessment reports, website portfolios, and any other <strong>must see links you want to share with potential employers</strong> and recruiters. Put your best self forward with just a few clicks!',

        linkName: 'Title',
        linkValue: 'URL Link',
        addLink: 'Add a link',
    },

    studyPrograms: {
        title: 'My education',
        titleWhenEmpty: 'Your education is the key to unlocking some amazing opportunities!',
        emptyButtonText: 'Add education',

        modalTitle: "What's your educational background?",
        prompt:
            'Your education is the key to unlocking some amazing opportunities! Give your future employers a glimpse of who you are by adding your educational background.',

        add: 'Add new education',

        selectSchool: 'Select your school',
        studyProgram: 'Study program',
        campus: 'Campus',
        degree: 'Degree',
        field: 'Field of study',
        startDate: 'Start date',
        endDate: 'End date',
    },

    closeModal: {
        title: 'You have unsaved changes! Do you want to save them before closing?',
    },
};
